import {afterRenderEffect, ChangeDetectorRef, Component, effect, inject, Input, OnInit, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {
  IonButton, IonButtons, IonContent, IonDatetime,
  IonHeader, IonIcon,
  IonImg,
  IonInput,
  IonItem,
  IonLabel, IonModal, IonSelect, IonSelectOption,
  IonTextarea, IonTitle, IonToolbar, ModalController
} from "@ionic/angular/standalone";
import {CurrencyPipe, DatePipe} from "@angular/common";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {CommonService} from "../../core/common.service";
import {components, dateFormat, errorMessages, formTypes, messagesColor} from "../../configs/config";
import {AlertService} from "../../core/alert.service";
import {LanguageService} from '../../core/language.service';
import {SelectCountryComponent} from '../../pages/contact/contact-form/select-country/select-country.component';
import {AuthService} from '../../auth/auth.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-enquire-modal',
    templateUrl: './enquire-modal.component.html',
    styleUrls: ['../../pages/contact/contact-form/contact-form.component.scss', './enquire-modal.component.scss'],
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
      CommonModule,
      TranslateModule,
      IonItem, IonInput, IonTextarea, IonButton, IonImg, IonLabel, CurrencyPipe, IonHeader, IonToolbar, IonTitle, ReactiveFormsModule, IonSelect, IonSelectOption, IonModal, IonDatetime, IonButtons, IonIcon, SelectCountryComponent, IonContent
    ],
    providers: [DatePipe]
})
export class EnquireModalComponent  implements OnInit {

  @Input() property: any;
  form = new FormGroup({
    name: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    contactNumber: new FormControl('', Validators.required),
    leaseDuration: new FormControl('', Validators.required),
    moveInDate: new FormControl('', Validators.required),
    message: new FormControl('', Validators.required),
    propertyId: new FormControl('', Validators.required),
  });
  modalController: ModalController = inject(ModalController);
  alertService: AlertService = inject(AlertService);
  commonService: CommonService = inject(CommonService);
  languageService: LanguageService = inject(LanguageService);
  formTextContent: any;
  token: string | null = '';
  user: any;
  constructor(private authService: AuthService, private cds: ChangeDetectorRef) {
    effect(async () => {
      if (this.languageService.lang()) {
        this.formTextContent = await this.languageService.loadContent(components.forms);
      }
    });
    afterRenderEffect(async () => {
      this.token = localStorage.getItem('access_token');
      this.cds.detectChanges();
      if (this.token) {
      }
      })
  }

  async ngOnInit() {
    this.form.controls.propertyId.patchValue(this.property._id);
    try {
      this.user = await this.authService.getUser();
      console.log('user', this.user);
      if (this.user) {
        this.form.patchValue({
          email: this.user.email,
          contactNumber: this.user.phone_number,
          name: `${this.user.first_name ?? ''} ${this.user.last_name ?? ''}`,
        });
      }
    } catch (e) {}
    this.formTextContent = await this.languageService.loadContent(components.forms);
  }
  async sendRequest() {
    console.log(this.form.value);
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      // await this.alertService.showToast(messagesColor.error, errorMessages.fillAllTheFields);
      return;
    }
    try {
      const data: any = this.form.value;
      data.formType = formTypes.b2c;
      data.propertyNumber = this.property?.propertyNumber;
      data.propertyName = this.property?.propertyName ?? '';
      data.unitType = this.property?.subCatName.nameEn;
      await this.commonService.sendEnquire(data);
      await this.alertService.showToast(messagesColor.success, this.formTextContent?.formErrorMessages.success);
      this.form.reset();
      await this.modalController.dismiss();
    } catch (error) {
      await this.alertService.showToast(messagesColor.error, this.formTextContent?.formErrorMessages.error);
    }
  }

  dataPipe: DatePipe = inject(DatePipe);
  datePicked($event: any) {
    const date = this.dataPipe.transform($event.detail.value, dateFormat);
    this.form.controls.moveInDate.patchValue(date);
  }
  prefix: string = '+966';
  countrySelected($event: any) {
    this.prefix = $event;
  }
}
